// Generated file : do not modify
export enum CaisseTypes
{
  NONE = 0,
  URSSAF,
  COMPLEMENTAIRE
};

export enum CaissePeriodes
{
  NONE = 0,
  DSN,
  DSN_MOIS,
  MOIS,
  TRIMESTRE,
  ANNEE
};

export enum CaissePrelevePars
{
  NONE = 0,
  URSSAF,
  AUDIENS
};

export enum CaisseArrondis
{
  NONE = 0,
  CENT,
  EURO
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Caisses
export default class Caisse  {
  // Identifiant unique
  public id: number;
  // Code
  public code: number;
  // Nom
  public nom: string;
  // Type
  public type: CaisseTypes;
  // Compte
  public compte: number;
  // Sous-compte
  public sousCompte: string;
  // Période
  public periode: CaissePeriodes;
  // Prélevé par
  public prelevePar: CaissePrelevePars;
  // Arrondi
  public arrondi: CaisseArrondis;
  // Adresse
  public adresseId: number;
  // Adresse
  public adresse1: string;
  // Complément d'adresse
  public adresse2: string;
  // Code postal
  public codePostal: string;
  // Ville
  public ville: string;
  // RIB
  public ribId: number;
  // IBAN
  public iban: string;
  // RIB AGETA
  public ribAgetaId: number;
  // IBAN AGETA
  public ibanAgeta: string;
  // SIRET
  public siret: string;
  // Départements
  public departements: string;
  // Préfixe URSSAF
  public prefixUrssaf: string;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = 0;
    this.nom = '';
    this.type = CaisseTypes.NONE;
    this.compte = 0;
    this.sousCompte = '';
    this.periode = CaissePeriodes.NONE;
    this.prelevePar = CaissePrelevePars.NONE;
    this.arrondi = CaisseArrondis.NONE;
    this.adresseId = 0;
    this.adresse1 = '';
    this.adresse2 = '';
    this.codePostal = '';
    this.ville = '';
    this.ribId = 0;
    this.iban = '';
    this.ribAgetaId = 0;
    this.ibanAgeta = '';
    this.siret = '';
    this.departements = '';
    this.prefixUrssaf = '';
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Caisse): Caisse {
    const newCaisse: Caisse = new Caisse();
    newCaisse.id = obj.id;
    newCaisse.code = obj.code;
    newCaisse.nom = obj.nom;
    newCaisse.type = obj.type;
    newCaisse.compte = obj.compte;
    newCaisse.sousCompte = obj.sousCompte;
    newCaisse.periode = obj.periode;
    newCaisse.prelevePar = obj.prelevePar;
    newCaisse.arrondi = obj.arrondi;
    newCaisse.adresseId = obj.adresseId;
    newCaisse.adresse1 = obj.adresse1;
    newCaisse.adresse2 = obj.adresse2;
    newCaisse.codePostal = obj.codePostal;
    newCaisse.ville = obj.ville;
    newCaisse.ribId = obj.ribId;
    newCaisse.iban = obj.iban;
    newCaisse.ribAgetaId = obj.ribAgetaId;
    newCaisse.ibanAgeta = obj.ibanAgeta;
    newCaisse.siret = obj.siret;
    newCaisse.departements = obj.departements;
    newCaisse.prefixUrssaf = obj.prefixUrssaf;
    newCaisse.canUpdate = obj.canUpdate;
    newCaisse.canDelete = obj.canDelete;
    newCaisse.display = obj.display;
    newCaisse.notifDefType = obj.notifDefType;
    return newCaisse;
  }

  public toJsonCaisse (): string {
    const json = {
      code: this.code,
      nom: this.nom,
      type: this.type,
      compte: this.compte,
      sousCompte: this.sousCompte,
      periode: this.periode,
      prelevePar: this.prelevePar,
      arrondi: this.arrondi,
      adresseId: this.adresseId,
      adresse1: this.adresse1,
      adresse2: this.adresse2,
      codePostal: this.codePostal,
      ville: this.ville,
      ribId: this.ribId,
      iban: this.iban,
      ribAgetaId: this.ribAgetaId,
      ibanAgeta: this.ibanAgeta,
      siret: this.siret,
      departements: this.departements,
      prefixUrssaf: this.prefixUrssaf,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromCaisse (obj: Caisse): void {
    this.id = obj.id;
    this.code = obj.code;
    this.nom = obj.nom;
    this.type = obj.type;
    this.compte = obj.compte;
    this.sousCompte = obj.sousCompte;
    this.periode = obj.periode;
    this.prelevePar = obj.prelevePar;
    this.arrondi = obj.arrondi;
    this.adresseId = obj.adresseId;
    this.adresse1 = obj.adresse1;
    this.adresse2 = obj.adresse2;
    this.codePostal = obj.codePostal;
    this.ville = obj.ville;
    this.ribId = obj.ribId;
    this.iban = obj.iban;
    this.ribAgetaId = obj.ribAgetaId;
    this.ibanAgeta = obj.ibanAgeta;
    this.siret = obj.siret;
    this.departements = obj.departements;
    this.prefixUrssaf = obj.prefixUrssaf;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareCaisse (value: Caisse): boolean {
    return (this.toJsonCaisse() == value.toJsonCaisse());
  }

  public cloneCaisse (): Caisse {
    return Caisse.fromJson(this);
  }

  public static listComplementaires (): Promise<Caisse[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/caisses/listComplementaires', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Caisse[] = [];
              res.data.forEach(( a: Caisse ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listPrevoyance (): Promise<Caisse[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/caisses/listPrevoyance', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Caisse[] = [];
              res.data.forEach(( a: Caisse ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listUrssaf (): Promise<string[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/caisses/listUrssaf', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: string[] = [];
              res.data.forEach(( a: string ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/caisses/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(caisses: Caisse[]) {
  }
}
